import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8767f3b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product-index"
};
const _hoisted_2 = {
  class: "product-page"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "产品形态", -1));
const _hoisted_4 = {
  class: "product-content"
};
const _hoisted_5 = {
  class: "product-tips mr"
};
const _hoisted_6 = {
  class: "img-icon",
  alt: ""
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "product-cell"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "cell-title"
}, "独立产品"), /*#__PURE__*/_createElementVNode("p", {
  class: "cell-text"
}, " 以完整的软件应用或服务的形式出现，智能体拥有完善的用户界面，支持丰富的交互操作，能够独立完成复杂的安全知识查询、文档分析等任务 ")], -1));
const _hoisted_8 = {
  class: "product-tips"
};
const _hoisted_9 = {
  class: "img-icon",
  alt: ""
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "product-cell"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "cell-title"
}, "API集成"), /*#__PURE__*/_createElementVNode("p", {
  class: "cell-text"
}, " 与其他软件或系统相连，提供其安全知识服务的同时，允许开发者在自己的应用中调用智能体的功能，如浏览器或企业管理系统。这种部署形态极大地扩展了智能体的应用场景和灵活性，使其能够作为后端服务支持多种前端应用 ")], -1));
export function render(_ctx, _cache) {
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [[_directive_lazy, require('@/assets/img/agent/productIcon.png')]]), _createTextVNode(" 独立产品 "), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [[_directive_lazy, require('@/assets/img/agent/productIcon.png')]]), _createTextVNode(" API集成 "), _hoisted_10])])])]);
}